import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const exportToExcel = (records, labels, fileName = "products.xlsx") => {
    if (!records || records.length === 0) {
        console.warn("No records found to export");
        return;
    }

    // Map data to include readable column headers (using labels if available)
    const exportData = records.map((item) => {
        let row = {};
        Object.keys(item).forEach((key) => {
            // If the key contains spaces or special characters, assume it's already a display header
            // and use it as-is. Otherwise, generate a readable header from snake_case keys.
            let header;
            if (/[^a-zA-Z0-9_]/.test(key)) {
                header = key;
            } else {
                const keyTitle = key ? key.replace(/_/g, ' ')
                        .toLowerCase()
                        .split(' ')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ')
                    : '';
                header = labels?.[key]?.title || keyTitle || key;
            }
            row[header] = item[key];
        });
        return row;
    });

    // Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // Create a new workbook and append worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

    // Generate Excel and trigger download
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, fileName);
};
